
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.8529 8.7798C5.6236 8.90687 5.33176 8.80098 5.18584 8.56804L5.14414 8.50451L3.78919 5.47627C3.76834 5.45509 3.76834 5.41274 3.76834 5.3704C3.76834 5.30687 3.78919 5.24333 3.83087 5.20098C3.87257 5.15862 3.93511 5.11627 3.99764 5.13745C4.06018 5.13745 4.10186 5.15863 4.14356 5.17982L5.74867 6.34451C5.93627 6.47156 6.18643 6.51393 6.41572 6.42922L13.9618 3.0198C12.6069 1.4104 10.3764 0.351562 7.85407 0.351562C3.72665 0.351562 0.391357 3.1892 0.391357 6.68333C0.391357 8.58922 1.39193 10.3045 2.9762 11.4692C3.10127 11.5539 3.18466 11.7233 3.18466 11.8716C3.18466 11.9351 3.18466 11.9775 3.16381 12.041L2.83028 13.3116C2.80943 13.3751 2.78858 13.4386 2.78858 13.5022C2.78858 13.6504 2.89282 13.7563 3.03874 13.7563C3.08044 13.7563 3.14297 13.7351 3.18466 13.7139L4.81061 12.761C4.99823 12.6339 5.22752 12.6127 5.43598 12.6763C6.22813 12.9092 7.0411 13.0151 7.87492 13.0151C12.0023 13.0151 15.3376 10.1775 15.3376 6.70451C15.3376 5.66687 15.0458 4.6504 14.483 3.78214L5.89457 8.75863L5.8529 8.7798Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'WechatPay',
    }) as DefineComponent
    </script>
    